import { resetAuthStore } from '@v2/domains/auth/store/auth.store'
import { useAppNavigation } from '@v2/domains/routing/hooks/useAppNavigation.hook'
import { destroyUILocalStore } from '@v2/domains/ui/store/ui.store'
import { resetUserSessionStore } from '@v2/domains/user/store/user.store'
import { useAppDispatch } from '@v2/store/hooks'

import { appLocalStorage } from 'src/common/libs'

const useLogout = () => {
  const dispatch = useAppDispatch()
  const { navigateTo } = useAppNavigation()
  return {
    mutate: () => {
      dispatch(resetAuthStore())
      dispatch(resetUserSessionStore())
      dispatch(destroyUILocalStore())
      appLocalStorage.clear()

      navigateTo('LOGIN', {}, { includeOrgPrefix: false, hardRedirect: true })
    },
  }
}

export default useLogout
